import React from "react";
import { Box, Typography } from "@mui/material";
import ConstructionOutlinedIcon from "@mui/icons-material/ConstructionOutlined";

interface Props {
  title: string;
}

const VendorPlaceholder: React.FC<Props> = ({ title }) => (
  <Box>
    <Typography
      sx={{
        fontSize: 26,
        fontWeight: 800,
        color: "#0f172a",
        letterSpacing: "-0.02em",
        mb: 0.5,
      }}
    >
      {title}
    </Typography>
    <Typography sx={{ fontSize: 14, color: "#64748b", mb: 4 }}>
      This section is under development
    </Typography>
    <Box
      sx={{
        bgcolor: "#ffffff",
        borderRadius: "14px",
        border: "1px solid #e2e8f0",
        boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        py: 10,
      }}
    >
      <ConstructionOutlinedIcon
        sx={{ fontSize: 48, color: "#94a3b8", opacity: 0.4, mb: 2 }}
      />
      <Typography sx={{ fontSize: 15, fontWeight: 600, color: "#64748b" }}>
        Coming Soon
      </Typography>
      <Typography sx={{ fontSize: 12, color: "#94a3b8", mt: 0.5 }}>
        The {title.toLowerCase()} feature is being built
      </Typography>
    </Box>
  </Box>
);

export default VendorPlaceholder;
